<template><div><h1>VUX V2.3.7 released</h1>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[feature] Add prop:show to control visibility #1538</li>
<li>[fix] Fix range error with format YYYY-MM #1358</li>
<li>[feature] Add prop:hourList prop:minuteList</li>
<li>[fix] startDate year should overwrite minYear #1358</li>
</ul>
<h2><a href="/en/components/popup-picker.html">PopupPicker</a></h2>
<ul><li>[feature] Add slot:title</li>
</ul>
<h2><a href="/en/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[feature] Add slot:each-item</li>
</ul>
<h2><a href="/en/components/popup.html">Popup</a></h2>
<ul><li>[fix] Fix missing mask when initial value is true #1555</li>
</ul>
<h2><a href="/en/components/x-number.html">XNumber</a></h2>
<ul><li>[fix] fix value type #1554</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.3.7 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.3.7-113.vue?0079b4c2